import { motion } from 'framer-motion';

interface ProgressBarProps {
  duration?: number; // Duration in seconds (default: 5)
  onComplete?: () => void; // Callback when animation completes
  className?: string;
}

export const ProgressBar = ({ duration = 5, onComplete, className }: ProgressBarProps) => {
  return (
    <div className={`w-full h-[6px] bg-osGrey-4 rounded-full overflow-hidden ${className}`}>
      <motion.div
        className="h-full bg-osBlack rounded-full"
        initial={{ width: "0%" }}
        animate={{ width: "100%" }}
        transition={{
          duration: duration,
          ease: "linear"
        }}
        onAnimationComplete={onComplete}
      />
    </div>
  );
};

